/**
 * Modulo Fatturazione elettronica: accessibile a tutti gli utenti autenticati.
 * Passare l'oggetto `user` da useAuth(), oppure una email non vuota.
 */
export function canAccessFatturazioneElettronica(userOrEmail) {
  if (userOrEmail == null) return false;
  if (typeof userOrEmail === "object") return true;
  if (typeof userOrEmail === "string") return userOrEmail.trim().length > 0;
  return false;
}
